/**
 * Feature rollout toggle feature auto-registration and exports
 *
 * This module automatically registers the feature-rollout-toggle feature when imported,
 * making it work seamlessly with both static and dynamic imports.
 */

import { autoRegisterFeature } from '@store/features/factory';

import { featureToggleFeature } from './store/feature';

// Auto-register the feature when this module is imported
autoRegisterFeature(featureToggleFeature);

// Export hooks
export * from './hooks';

// Export components
export * from './components';

// Export store (all store-related exports)
export * from './store';

// Export types
export * from './types';
